export enum NotificationType {
    none,
    success,
    error
}
